define(
  'resultsSortBy',[
    'paramsConfig',
    'paramsObserver',
    'sortByConfig',
    'touchHelper'
  ],
  (
    paramsConfig,
    paramsObserver,
    sortByConfig
  ) => {
    'use strict';

    const sortBySelect = document.getElementById('nhs_sortBySelect');

    function bindSortByEvent() {
      const sortBySelect = document.querySelector('#nhs_sortBySelect');

      if (sortBySelect) {
        sortBySelect.removeEventListener('change', sortOrderChanged);
        sortBySelect.addEventListener('change', sortOrderChanged);
      }
    }

    function trackFilterPriceEvent() {
      const eventGa4 = {
        eventName: 'search_filters',
        params: {
          click_target: 'Sort By',
          search_value: paramsObserver.getParameter('SortBy')
        },
        eventType: 'GA4Event'
      };
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }

    function sortOrderChanged(event) {
      const target = event.target;
      if (!target) {
        return;
      }

      const value = target.value;
      const locationType = target.dataset.locationType;
      const locationValue = target.dataset.locationValue;
      const parameters = paramsConfig.getSortByParameters(value);

      /*
             * BDXNHS-8623: New rules for the sort functionality
             * We need to add the second sort property, when the location is selected,
             * sort by must match first sort by and first sort by should be the location
             * Also, the sort order should be applied to the second sort
             * Synthetic location not contains matchs for search result on the API Code
             */
      if (locationType && (locationType !== 'Market' && locationType !== 'SyntheticGeo')) {
        let sortOptionChosen = parameters.SortBy;
        const sortSecondOrder = parameters.SortOrder;

        // BDXWEBAPI-3018: we need to change the second sort property to apply the new rule
        const isZipCodeLocation = locationType && locationType === 'Zip';
        const isSortByRandom = sortOptionChosen && sortOptionChosen === 'Random';

        if (isZipCodeLocation && isSortByRandom) {
          sortOptionChosen = 'Distance';
        }

        // The Enum for SortBy doesn't contain the Zip element instead it's PostalCode
        parameters.SortBy = (isZipCodeLocation ? 'PostalCodeWithBasics' : locationType);
        parameters.SortFirstBy = locationValue;
        parameters.SortSecondBy = sortOptionChosen;
        parameters.SortSecondOrder = sortSecondOrder;
        parameters.SortOrder = false;
      }

      paramsObserver.setParameters(parameters);
      trackFilterPriceEvent();
      paramsObserver.commit();
    }

    function onUpdate(data) {
      const srpType = data.parametersChanged.SrpType;

      if (data.isMoreResults || !srpType) {
        return;
      }

      updateOptions(srpType);
    }

    function updateOptions(srpType) {
      let optionsString = '';
      let sortByValue = 'default';
      const options = sortByConfig.getSortOptions(srpType);

      for (const config in options) {
        if (options.hasOwnProperty(config)) {
          optionsString += "<option value='" + config + "' data-event='true' data-event-type='change' data-segment-event='true' data-segment-event-event='Results Sorted' data-segment-event-sort_value='" + options[config] + "'>" + options[config] + '</option>';
        }
      }

      if (sortByConfig.isValid(srpType, sortBySelect.value)) {
        sortByValue = sortBySelect.value;
      }

      sortBySelect.innerHTML = optionsString;

      for (let index = 0; index < sortBySelect.options.length; index += 1) {
        if (sortBySelect.options[index].value === sortByValue) {
          sortBySelect.selectedIndex = index;
          break;
        }
      }
    }

    bindSortByEvent();
    paramsObserver.subscribe('beforeResultsLoad', onUpdate);
    paramsObserver.subscribe('resultsLoaded', bindSortByEvent);
  }
);

